export const Config = {
  API_URL: 'https://cs.infinityevcharge.com/v1',
  REACT_APP_API_KEY: 'AIzaSyBa0yPphimIer5WqWyEes0Ui6qOu9MuNQE',
  EMITTER_URL: 'realtime.infinityevcharge.com',
}
